import { Icon } from '@terminus/dqh-web-ui';
import styles from './index.module.scss';

export type TagProps = {
  type: string;
  title: string;
  style?: React.CSSProperties;
  icon?: string;
};

export const Tag = (props: TagProps) => {
  const { type, title, style: pStyle, icon } = props;
  const tagClass =
    type === 'warnning'
      ? styles.bTagWarning
      : type === 'normal'
      ? styles.bTagNormal
      : styles.bTagInfo;
  return (
    <div
      style={{ ...pStyle, display: 'inline-flex', alignItems: 'center' }}
      className={tagClass}
    >
      {icon ? <Icon name={icon} size={18} /> : null}
      {title}
    </div>
  );
};
